import { ReactNode } from 'react';

export type TableRowProps = {
	children: ReactNode | ReactNode[];
};

export const TableRow = ({ children }: TableRowProps) => <tr>{children}</tr>;
